export enum TemplateEnum {
  CopyrightStatements = "copyrightStatements",
  PrivacyStatements = "privacyStatements",
  ReviewGuideline = "reviewGuideline",
}
export default TemplateEnum;
